import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const theme = {
  primary: '#d25e35',
  secondary: '#e57373',
  accent: '#9c27b0',
  error: '#FF5252',
  warning: '#FFC107',
  info: '#2196F3',
  success: '#4CAF50'
}

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
